/**
 * A row of the message_templates table (gladstone-data-retriever).
 * `content` maps to the DB column `template_html`.
 * A template is resolved at send time by institution → coach → language, so
 * `coachId` / `institutionId` being null means "applies to all".
 */
export interface MessageTemplate {
	id: number | null;
	name: string;
	languageCode: string | null;
	coachId: number | null;
	institutionId: number | null;
	subject: string | null;
	origin: string | null;
	content: string;
}

/**
 * A variable that can be inserted into a template. `name` matches a
 * {{snake_case}} placeholder and a column of user_state_tmp.
 */
export interface TemplateVariable {
	name: string;
	type: string;
}

/**
 * Result of testing a template against a participant's user_state.
 * `unresolvedVariables` are placeholders that had no value for that participant
 * (left untouched in the rendered output).
 */
export interface MessageTemplatePreviewResult {
	content: string | null;
	subject: string | null;
	unresolvedVariables: string[];
}

/** An empty template, used when creating a new one. */
export const emptyMessageTemplate = (): MessageTemplate => ({
	id: null,
	name: "",
	languageCode: "ENGLISH",
	coachId: null,
	institutionId: null,
	subject: null,
	origin: null,
	content: "",
});
